import { useRef } from "react";
import { Link, Navigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/stores/auth-store";

export function LogoutSuccessPage() {
  const { isAuthenticated } = useAuthStore();
  // Snapshotted at mount, like GuestGuard: a session started later in another
  // tab flips isAuthenticated here too, and must not be signed out by this
  // page just sitting open.
  const wasAuthenticatedAtMount = useRef(isAuthenticated);

  // A direct or bookmarked visit that bypassed /logout would still be signed
  // in, so route through /logout to actually clear the session. /logout sends
  // us back here once isAuthenticated is false, so there's no redirect loop.
  if (wasAuthenticatedAtMount.current) {
    return <Navigate to="/logout" replace />;
  }

  return (
      <div className="flex flex-col">
          <h1 className="text-4xl font-semibold tracking-tight">
              Thank you for using Appio
          </h1>
          <p className="mt-3 text-muted-foreground">
              Hope to see you back soon.
          </p>
          <Button asChild className="text-base mt-6">
              <Link to="/login">Log back in</Link>
          </Button>
      </div>
  );
}
